import React from 'react';

import SavedSearchesBar from 'src/common/ui/SavedSearchesBar';

import {
  useSavedTrackSearches,
  SavedTrackSearchState,
  MAX_SAVED_TRACK_SEARCHES,
} from '../hooks/useSavedTrackSearches';

interface SavedTrackSearchesBarProps {
  /** Applies a saved filter selection and re-runs the query. */
  readonly onLoadSearch: (state: SavedTrackSearchState) => void;
}

/** Track page's saved filter chips. Presentation lives in the shared bar. */
const SavedTrackSearchesBar: React.FC<SavedTrackSearchesBarProps> = ({
  onLoadSearch,
}) => {
  const { entries, remove } = useSavedTrackSearches();

  return (
    <SavedSearchesBar<SavedTrackSearchState>
      entries={entries}
      remove={remove}
      onLoadSearch={onLoadSearch}
      label="Saved Searches:"
      hint={`(max ${MAX_SAVED_TRACK_SEARCHES} — oldest removed automatically)`}
      itemTestId="saved-track-search-chip"
    />
  );
};

export default SavedTrackSearchesBar;
